import type { IconType } from '@sdb/planning-ui/ui-3/packages/icons/__generated__';

export const keyIconMap: {
  [key: string]: IconType;
} = {
  ARROWUP: 'caret-up',
  ARROWDOWN: 'caret-down',
  ARROWLEFT: 'caret-left',
  ARROWRIGHT: 'caret-right'
};
